import { Field, type FieldProps, useFormikContext } from 'formik';

import SelectEmailAddress from '../select/SelectEmailAddress';

type Props = {
  callback?: (option: string | string[] | undefined) => void;
  label?: string;
  name: string;
  multiple?: boolean;
  required?: boolean;
};

const FormikEmailAddressSelector: React.FC<Props> = ({ callback, name, label, ...rest }) => {
  const { setFieldValue, setFieldTouched } = useFormikContext();

  const onChange = (value: string | string[] | undefined) => {
    setFieldValue(name, value);
    setFieldTouched(name, true);
    if (callback) callback(value);
  };

  return (
    <Field name={name}>
      {({ field, meta }: FieldProps<string | string[] | undefined>) => (
        <SelectEmailAddress
          label={label}
          onChange={onChange}
          value={field.value}
          error={meta.error}
          touched={meta.touched}
          {...rest}
        />
      )}
    </Field>
  );
};

export default FormikEmailAddressSelector;
